// ===== Enums =====

import {
    PAGE_ROUTE,
    READER_PARAMS_TYPE,
} from '../enums';
import {
    ZOOM_LEVEL,
} from '../components/Editor/elements/enums';

// ===== Interfaces =====

import {
    IReaderContentsTableItemHrefArgs,
} from '../interfaces';

/**
 * Builds browser-native hrefs for read-mode contents table rows.
 * Chapter links intentionally target zoom level 4 so chapters with sections do
 * not immediately resolve to their first section in a fresh tab.
 */
const buildReaderContentsTableItemHref = ({
    chapterId,
    sectionId,
}: IReaderContentsTableItemHrefArgs): string => {
    const normalizedChapterId = `${chapterId || ''}`.trim();
    if (!normalizedChapterId) {
        return `/${PAGE_ROUTE.book}`;
    }

    const normalizedSectionId = `${sectionId || ''}`.trim();
    const searchParams = new URLSearchParams([
        [READER_PARAMS_TYPE.chapterId.toString(), normalizedChapterId],
    ]);

    if (normalizedSectionId) {
        searchParams.set(READER_PARAMS_TYPE.sectionId.toString(), normalizedSectionId);
        searchParams.set(READER_PARAMS_TYPE.zoom.toString(), ZOOM_LEVEL.five.toString());
    } else {
        searchParams.set(READER_PARAMS_TYPE.zoom.toString(), ZOOM_LEVEL.four.toString());
    }

    return `/${PAGE_ROUTE.book}?${searchParams.toString()}`;
};

export default buildReaderContentsTableItemHref;
